export default {
  listTitle: 'Пользователи',
  detailTitle: 'Пользователь',
  empty: 'Пользователи не найдены',
  columns: {
    id: 'ID',
    fullName: 'Имя',
    email: 'Email',
    phoneNumber: 'Телефон',
    type: 'Тип',
    utm_source: 'utm_source',
    utm_medium: 'utm_medium',
    utm_campaign: 'utm_campaign',
    utm_content: 'utm_content',
    utm_term: 'utm_term',
    telegram: 'Telegram',
    sendpulseId: 'SendPulse',
    verified: 'Verified',
    ledgerId: 'Кошелёк',
    ledgerUserId: 'Ledger UID',
    createdAt: 'Создан',
    details: 'Подробно',
    defaultAddress: 'Адрес',
    location: 'Координаты',
    whatsappId: 'WhatsApp',
    spTgLinked: 'Telegram ↔ SendPulse',
    updatedAt: 'Обновлён',
  },
  types: {
    user: 'Пользователь',
    courier: 'Курьер',
    restaurant: 'Ресторан',
    admin: 'Админ',
  },
  verified: {
    yes: 'Да',
    no: 'Нет',
    all: 'Все',
  },
  filters: {
    idPlaceholder: 'ID пользователя',
    namePlaceholder: 'Имя',
    emailPlaceholder: 'Email',
    phonePlaceholder: 'Телефон',
    typeAll: 'Все типы',
    telegramPlaceholder: 'Telegram',
    verifiedAll: 'Verified',
    reset: 'Сбросить',
  },
  actions: {
    copyId: 'Скопировать ID',
    copyIdSuccess: 'ID скопирован',
    copyIdFailed: 'Не удалось скопировать ID',
    copyValue: 'Скопировать',
    copyValueSuccess: 'Скопировано',
    copyValueFailed: 'Не удалось скопировать',
    openDetails: 'Подробнее',
    openDetailsNewWindow: 'Открыть в новом окне',
    openWallet: 'Открыть кошелёк',
    openWalletNewWindow: 'Открыть кошелёк в новом окне',
    openWhatsapp: 'WhatsApp',
    openTelegram: 'Telegram',
    openSendpulse: 'SendPulse',
  },
  errors: {
    loadList: 'Не удалось загрузить пользователей',
    loadDetail: 'Не удалось загрузить пользователя',
    missingId: 'Не указан ID пользователя',
  },
}
